import { render } from "./SegmentationsPanel.vue?vue&type=template&id=42730804&scoped=true"
import script from "./SegmentationsPanel.vue?vue&type=script&lang=ts"
export * from "./SegmentationsPanel.vue?vue&type=script&lang=ts"

import "./SegmentationsPanel.vue?vue&type=style&index=0&id=42730804&lang=scss&scoped=true"
import "./SegmentationsPanel.vue?vue&type=style&index=1&id=42730804&lang=scss"
script.render = render
script.__scopeId = "data-v-42730804"

export default script